// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
import { CoachClassCardClassSessionFragmentDoc } from './CoachClassCard.generated';
export type GenerateCoachClassCardsClassFragment = {
  __typename?: 'Class';
  slug?: string | null;
  name?: string | null;
  imageLink?: string | null;
  price?: number | null;
  isUserOnDiscoveryList?: boolean | null;
  isFreeEvent?: boolean | null;
  classId: string;
  coach?: {
    __typename?: 'Coach';
    id: string;
    user: { __typename?: 'User'; id: string; firstName: string };
  } | null;
  upcomingSessionsV2?: Array<{
    __typename?: 'CoachingSession';
    id: string;
    startAt: number;
    durationInMinute: number;
  }> | null;
};

export type GenerateCoachClassCardsEventFragment = {
  __typename?: 'Shindig';
  imageLink?: string | null;
  date: number;
  link: string;
  numGuests?: number | null;
  durationInMinute: number;
  shindigId: string;
  shindigName: string;
};

export type GenerateCoachClassCardsClassSessionFragment = {
  __typename?: 'CoachingSession';
  id: string;
  startAt: number;
  durationInMinute: number;
};

export type GenerateCoachClassCardsAllEventsClassFragment = {
  __typename: 'Class';
  slug?: string | null;
  name?: string | null;
  imageLink?: string | null;
  price?: number | null;
  isUserOnDiscoveryList?: boolean | null;
  isFreeEvent?: boolean | null;
  classId: string;
  coach?: {
    __typename?: 'Coach';
    id: string;
    user: { __typename?: 'User'; id: string; firstName: string };
  } | null;
  upcomingSessionsV2?: Array<{
    __typename?: 'CoachingSession';
    id: string;
    startAt: number;
    durationInMinute: number;
  }> | null;
};

export type GenerateCoachClassCardsAllEventsShindigFragment = {
  __typename: 'Shindig';
  imageLink?: string | null;
  date: number;
  link: string;
  numGuests?: number | null;
  durationInMinute: number;
  shindigId: string;
  shindigName: string;
};

export type GenerateCoachClassCardsAllEventsFragment =
  | GenerateCoachClassCardsAllEventsClassFragment
  | GenerateCoachClassCardsAllEventsShindigFragment;

export const GenerateCoachClassCardsEventFragmentDoc = gql`
  fragment GenerateCoachClassCards_Event on Shindig {
    shindigId: id
    shindigName: name
    imageLink
    date
    link
    numGuests
    durationInMinute
  }
`;
export const GenerateCoachClassCardsClassSessionFragmentDoc = gql`
  fragment GenerateCoachClassCards_ClassSession on CoachingSession {
    id
    ...CoachClassCard_ClassSession
  }
  ${CoachClassCardClassSessionFragmentDoc}
`;
export const GenerateCoachClassCardsClassFragmentDoc = gql`
  fragment GenerateCoachClassCards_Class on Class {
    classId: id
    slug
    name
    imageLink
    price
    isUserOnDiscoveryList
    isFreeEvent
    coach {
      id
      user {
        id
        firstName
      }
    }
    upcomingSessionsV2(ignoreFullSessions: $ignoreFullSessions) {
      ...GenerateCoachClassCards_ClassSession
    }
  }
  ${GenerateCoachClassCardsClassSessionFragmentDoc}
`;
export const GenerateCoachClassCardsAllEventsFragmentDoc = gql`
  fragment GenerateCoachClassCards_AllEvents on ClassAndShindig {
    __typename
    ...GenerateCoachClassCards_Event
    ...GenerateCoachClassCards_Class
  }
  ${GenerateCoachClassCardsEventFragmentDoc}
  ${GenerateCoachClassCardsClassFragmentDoc}
`;
